import { render, staticRenderFns } from "./After.vue?vue&type=template&id=35396be7&"
import script from "./After.vue?vue&type=script&lang=js&"
export * from "./After.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports